module.exports = __webpack_public_path__ + "img/br14.5e3b8e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br14.jpg
// module id = /zdH
// module chunks = 0